<template>
  <quick-entry-complete>
    <template v-slot:contents>
      <v-sheet
          max-width="840px"
          class="mx-auto pt-md-10 pb-md-0 pb-10 "
      >
        <v-row class="text-h6 text-md-h4" justify="center">
          買取ナンバー：{{ getBuyStateFormItems.buyNumber }}
        </v-row>
        <v-row class="pt-4 px-md-5 px-4" justify="center">
          この後のお手続きや問い合わせの際に必要となりますので、買取ナンバーをメモしていただくか、こちらの画面を印刷して保存ください。
          買取ナンバーは後ほどお送りするお申込み完了のメールにも記載しております。
        </v-row>
      </v-sheet>

      <v-sheet
          :outlined="$vuetify.breakpoint.mdAndUp"
          max-width="840px"
          class="mx-auto white py-md-10 mt-md-12"
      >
        <v-row class="px-md-10 pt-4 px-4">
          <v-col>
            <p>
              お申込みが完了いたしました！<br>
              お手続き、誠にありがとうございました。<br>
              <br>
              また進行状況は以下のページからご確認いただけます。
            </p>
          </v-col>
        </v-row>
        <v-row class="pt-3 pt-md-6 pb-12" justify="center">
          <v-btn
              class="secondary white--text text-subtitle-1 text-md-h6"
              :width="$vuetify.breakpoint.mdAndUp ? '500px' : '328px'"
              :height="$vuetify.breakpoint.mdAndUp ? '76px' : '48px'"
              :to="{name: 'BuyStatus'}"
              target='_self'
          >
            進行状況を確認する
          </v-btn>
        </v-row>
        <v-row class="pb-7 pb-md-4 px-md-10 px-4">
          <v-col>
            <p>
              完了後は受け取った本を様々な読み手に届け、活用してまいります。<br>
              どうぞ引き続き、よろしくお願いいたします。
            </p>
          </v-col>
        </v-row>
      </v-sheet>

    </template>
  </quick-entry-complete>
</template>

<script>
import QuickEntryComplete from "../../organisms/buy/quick-entry-complete.vue"
import {mapGetters} from "vuex";

export default {
  name: "charibon-entry-complete",
  components: {
    QuickEntryComplete,
  },
  computed: {
    ...mapGetters({
      getBuyStateFormItems: 'buyState/getFormItems',
    }),
  },
  mounted() {
    // ブラウザバックの抑制
    if (window.history && window.history.pushState) {
      history.pushState(null, null, location.href);
      window.addEventListener('popstate', (e) => {
        history.go(1);
      });
    }
  }
}
</script>
